<template>
  <!--  -->
  <div class="side-panel right com-right hf osy mr-30">
    <div class="side-panel-bg p-20 pb-0">
      <h1 class="f-20 c-satwo">动环监测 <img src="/imgs/titleicon.png" class="ml-10"></h1>
      <div class="mt-20">
        <div class="monitorcont mb-8">
          <dl v-for="(alert, index) in datamonitoringData" :key="index" class="f-20 tc b">
            <dt :class="`c-color${index + 1}`">{{ alert.count }}</dt>
            <dd><img :src="getIconSrc(index)" alt="告警图标"></dd>
            <dd class="f-10">{{ alert.description }}</dd>
          </dl>
        </div>
        <div style="text-align: center;"><img src="/imgs/saline.png"></div>
        <div style="width: 100%; height: 95px;">
          <div class="dcvideoVideo">
            <div class="videoVideoLft"><img src="/imgs/videoImgs/video03.png" class="video-img"/></div>
            <div class="videoVideoRt"><img src="/imgs/videoImgs/video05.png" class="video-img"/></div>
          </div>
        </div>
      </div>
    </div>

    <div class="side-panel-bg mb-20 p-20 mt-20">
      <h1 class="f-20 c-satwo">网络安全 <img src="/imgs/titleicon.png" class="ml-10"></h1>
      <chart-line-flow :datasets="datanetworkSecurity" fill showLegend class="f1 mt-10"
                       style="height: 160px;"></chart-line-flow>
    </div>

    <div class="side-panel-bg newsList mb-20 p-20 mt-20">
      <h1 class="f-20 c-satwo">实时事件 <img src="/imgs/titleicon.png" class="ml-10"></h1>
      <div id="publishMain" class="centerNews">
        <div id="publishMain1">
          <div class="centerNewsCon" v-for='(news , index) in datacontentMainNews' :key='index'>
            <div class="centerNewsContitle f-12 c-blue pt-5">{{ news.data }} {{ news.title }}</div>
            <div class="f-14 ellipsisBox"> {{ news.content }}</div>
            <img class="blikunnewsicon" src="/imgs/blikunnewsicon.png">
          </div>
        </div>
        <div id="publishMain2"/>
      </div>
    </div>
  </div>
</template>

<script>
import chartLineFlow from './chart-line-flow'

export default {
  name: 'com-right',
  components: {
    chartLineFlow,
  },
  props: ['datamonitoringData', 'datanetworkSecurity', 'dataenergyTrend', 'datacontentMainNews'],
  data() {
    return {
      timer: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.rollUp();
    });
  },
  beforeDestroy() {
    this.timer = null;
    clearInterval(this.timer);
  },
  methods: {
    /*向上轮播*/
    rollUp() {
      let ul1 = document.getElementById("publishMain1");
      let ul2 = document.getElementById("publishMain2");
      let box = document.getElementById("publishMain");
      ul2.innerHTML = ul1.innerHTML;
      box.scrollTop = 0;

      function rollStart() {
        console.log(box.scrollTop, ul1.scrollHeight)
        if (box.scrollTop >= 386) {
          box.scrollTop = 0;
        } else {
          box.scrollTop++;
        }
      }

      //this.timer = setInterval(rollStart, 50);
    },
    getIconSrc(index) {
      // 定义图标路径的映射
      const iconPaths = [
        '/imgs/monitorIcon1.png',
        '/imgs/monitorIcon2.png',
        '/imgs/monitorIcon3.png',
        '/imgs/monitorIcon4.png',
        '/imgs/monitorIcon5.png',
        '/imgs/monitorIcon6.png',
        '/imgs/monitorIcon7.png',
        '/imgs/monitorIcon8.png'
      ];
      return iconPaths[index];
    },
  }
}
</script>
<style>
.monitorcont {
  overflow: hidden;
}

.monitorcont dl {
  width: 25%;
  float: left;
}

.monitorcont dl dt {
  margin-bottom: 2px;
}

.monitorcont dl dd:last-child {
  font-size: 10px;
  margin-bottom: 5px;
}

.c-color1 {
  color: #66FFFF;
}

.c-color2 {
  color: #FBDC4E;
}

.c-color3 {
  color: #FD5465;
}

.c-color4 {
  color: #0A9BBC;
}

.c-color5 {
  color: #0ADB8B;
}

.c-color6 {
  color: #08D4EA;
}

.c-color7 {
  color: #CC9F14;
}

.c-color8 {
  color: #115FC3;
}

.newsList {
  padding-right: 0;
}

.centerNews {
  width: 100%;
  height: 200px;
  overflow-y: scroll;
  margin: 8px 0 20px;
}

.centerNewsCon {
  margin-top: 10px;
  padding: 0 10px;
  width: 100%;
  height: 55px;
  background: url("/imgs/blikunnewsbg.png") no-repeat;
  background-size: 100% 55px;
  position: relative;
}

.centerNewsCon .centerNewsContitle {
  width: 90%;
  height: 24px;
  line-height: 22px;
  list-style-type: disc;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 5px;
}

.centerNewsCon .ellipsisBox {
  list-style-type: disc;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 20px;
  margin-top: 5px;
}

.centerNewsCon .blikunnewsicon {
  position: absolute;
  right: 7px;
  top: 23px;
}

#publishMain1 {
  width: 100%;
}

.dcvideoVideo {
  margin-top: 10px;
  width: 100%;
  overflow: hidden;
}

.videoVideoLft {
  float: left;
  width: 49%;
  height: 89px;
  background: #123f46;
}

.videoVideoRt {
  float: right;
  width: 49%;
  height: 89px;
  background: #123f46;
}

.video-img {
  width: 100%;
  height: 89px;
}
</style>
